import type { ID } from '@octopus-do/octopus-project-core'
import { MessagesActions } from '@store/messagesSaga'
import { useDispatch } from 'react-redux'

import { useAuth } from '@/hooks'

type TutorialType =
  | 'onboarding_create_team'
  | 'onboarding_publish'
  | 'onboarding_dashboard'
  | 'onboarding_share'
  | 'onboarding_export'

export const useVideoTutorial = () => {
  const dispatch = useDispatch()

  const { messages } = useAuth()

  const tutorialMessages = messages.filter((message) =>
    message.type.startsWith('onboarding_')
  )

  const makeResult = (type: TutorialType) => {
    const messageByType = tutorialMessages.find(
      (message) => message.type === type
    )

    if (!messageByType) {
      return null
    }

    return messageByType.id
  }

  const handleViewedTutorial = (id: ID) => {
    dispatch(MessagesActions.viewed({ id }))
  }

  return {
    createTeamId: makeResult('onboarding_create_team'),
    publishId: makeResult('onboarding_publish'),
    dashboardId: makeResult('onboarding_dashboard'),
    shareId: makeResult('onboarding_share'),
    exportId: makeResult('onboarding_export'),
    handleViewedTutorial,
  }
}
